export default function Process() {
  const steps = [
    {
      number: 1,
      icon: 'ri-file-edit-line',
      title: 'Diseño de Hoja OMR',
      description: 'Creamos la plantilla personalizada según tus necesidades específicas',
      color: '#0D9488'
    },
    {
      number: 2,
      icon: 'ri-pencil-line',
      title: 'Aplicación del Examen',
      description: 'Los estudiantes completan las evaluaciones en las hojas diseñadas',
      color: '#F59E0B'
    },
    {
      number: 3,
      icon: 'ri-scan-line',
      title: 'Escaneo Digital',
      description: 'Procesamos las hojas con tecnología OMR de alta precisión',
      color: '#0D9488'
    },
    {
      number: 4,
      icon: 'ri-file-chart-line',
      title: 'Entrega de Informes',
      description: 'Recibe reportes detallados en Excel y PDF con análisis completo',
      color: '#F59E0B'
    }
  ];

  return (
    <section id="process" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-20">
          <div className="inline-flex items-center gap-2 bg-[#0D9488]/10 px-5 py-2 rounded-full mb-4">
            <i className="ri-flow-chart text-[#0D9488]"></i>
            <span className="text-[#0D9488] font-semibold text-sm">Cómo Trabajamos</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A2E] mb-3 md:mb-4 px-4">
            Proceso Simple en <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#D97706]">4 Pasos</span>
          </h2>
          <p className="text-base md:text-lg text-gray-500 max-w-2xl mx-auto px-4">
            Un flujo de trabajo optimizado para resultados rápidos y precisos
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-[60px] left-[12%] right-[12%] h-1 bg-gradient-to-r from-[#0D9488]/30 via-[#F59E0B]/30 to-[#0D9488]/30 rounded-full"></div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex flex-col items-center">
                  <div className="relative mb-4 md:mb-6">
                    <div className="w-[80px] h-[80px] md:w-[120px] md:h-[120px] rounded-full flex items-center justify-center shadow-lg z-10 relative" style={{ background: `linear-gradient(135deg, ${step.color}, ${step.color}dd)` }}>
                      <span className="text-2xl md:text-3xl font-bold text-white">{step.number}</span>
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-2xl p-4 md:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border border-gray-100 w-full">
                    <div className="w-10 h-10 md:w-14 md:h-14 rounded-2xl flex items-center justify-center mx-auto mb-3 md:mb-4" style={{ backgroundColor: `${step.color}15` }}>
                      <i className={`${step.icon} text-lg md:text-2xl`} style={{ color: step.color }}></i>
                    </div>
                    <h3 className="text-sm md:text-lg font-bold text-[#1A1A2E] mb-2 md:mb-3">
                      {step.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-500 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}